import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { superAdminApi } from '@/lib/api/superadmin';
import { toast } from 'sonner';

export function useSuperAdminOrganizations() {
  return useQuery({
    queryKey: ['superadmin', 'organizations'],
    queryFn: superAdminApi.getOrganizations,
  });
}

export function useSuperAdminUsers() {
  return useQuery({
    queryKey: ['superadmin', 'users'],
    queryFn: superAdminApi.getUsers,
  });
}

export function useSuperAdminOrgDetail(id: string) {
  return useQuery({
    queryKey: ['superadmin', 'organizations', id],
    queryFn: () => superAdminApi.getOrganizationDetail(id),
    enabled: !!id,
  });
}

export function useSuperAdminUserDetail(id: string) {
  return useQuery({
    queryKey: ['superadmin', 'users', id],
    queryFn: () => superAdminApi.getUserDetail(id),
    enabled: !!id,
  });
}

export function useImpersonate() {
  return useMutation({
    mutationFn: (userId: string) => superAdminApi.impersonate(userId),
    onSuccess: () => {
      toast.success("Impersonating user");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to impersonate");
    },
  });
}

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => superAdminApi.deleteUser(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['superadmin', 'users'] });
      toast.success("User deleted successfully");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to delete user");
    },
  });
}

export function useDeleteOrganization() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (orgId: string) => superAdminApi.deleteOrganization(orgId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['superadmin', 'organizations'] });
      toast.success("Organization deleted successfully");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to delete organization");
    },
  });
}
